import React, { useState, useEffect, useRef, useId } from 'react';
import RichText from 'components/RichText';
import LinkButton, { LINK_BUTTON_THEMES } from 'components/LinkButton';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './SummaryBlock.scss';

const SummaryBlock = ({ heading, textHtml, lang }) => {
  const [expanded, setExpanded] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef(null);
  const blockId = useId();

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [textHtml]);

  const onToggleBtnClick = () => {
    setExpanded(prev => !prev);
  };

  return (
    <div className="summary-block">
      {heading && <h2 className="summary-block__heading">{heading}</h2>}
      <div
        id={blockId}
        className={cn('summary-block__content-wrapper', {
          'summary-block__content-wrapper_expanded': expanded,
        })}
        style={{
          maxHeight: expanded ? `${contentHeight}px` : undefined,
        }}
      >
        <div ref={contentRef}>
          <RichText
            text={textHtml}
            className="summary-block__content rich-text_in-summary-block"
          />
        </div>
      </div>
      <LinkButton
        text={expanded ? lang.showLessLabel : lang.showMoreLabel}
        onClick={onToggleBtnClick}
        theme={LINK_BUTTON_THEMES.dark}
        additionalAttributes={{
          'aria-expanded': expanded,
          'aria-controls': blockId,
        }}
        className="summary-block__toggle-btn"
      />
    </div>
  );
};

SummaryBlock.propTypes = {
  heading: PropTypes.string,
  textHtml: PropTypes.string.isRequired,
  lang: PropTypes.shape({
    showMoreLabel: PropTypes.string.isRequired,
    showLessLabel: PropTypes.string.isRequired,
  }).isRequired,
};

export default SummaryBlock;
